import { render, staticRenderFns } from "./TableRiskAppraisal2_3x3.vue?vue&type=template&id=3a4fe0b7&scoped=true"
import script from "./TableRiskAppraisal2_3x3.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal2_3x3.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal2_3x3.vue?vue&type=style&index=0&id=3a4fe0b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4fe0b7",
  null
  
)

export default component.exports